// import { Injectable, Inject } from '@angular/core';
// import { MomentDateAdapter } from '@angular/material-moment-adapter';
// import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
// import * as moment from 'moment';

// @Injectable()
// export class CustomDateAdapter extends MomentDateAdapter {
//   constructor(@Inject(MAT_DATE_LOCALE) dateLocale: string) {
//     super(dateLocale);
//   }

//   // Override format function to apply "dd.MM.yyyy" format in both input & calendar
//   override format(date: moment.Moment, displayFormat: string): string {
//     return date ? date.format('DD.MM.YYYY') : '';
//   }
// }

import { Injectable, Inject } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';

// Ensure locales are imported (VERY IMPORTANT)
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/es';

@Injectable()
export class CustomDateAdapter extends MomentDateAdapter {
  constructor(@Inject(MAT_DATE_LOCALE) locale: string) {
    super(locale);
    moment.locale(locale); // Set the initial locale
  }

  // Override format function to apply "dd.MM.yyyy" format in both input & calendar
  override format(date: moment.Moment, displayFormat: string): string {
    return date ? date.format('DD.MM.YYYY') : '';
  }

  // Override setLocale to update moment's locale dynamically
  override setLocale(locale: string): void {
    super.setLocale(locale);
    moment.locale(locale); // Update moment's locale
  }
}
